<style lang="scss" scoped>
img {
    max-width: 300px;
    max-height: 300px;
    width: 100%;
    height: auto;

    @media (min-width: 1280px) {
        max-width: 384px;
        max-height: 384px;
    }
}

h2 {
    line-height: 1.25;

    @media (min-width: 1024px) {
        line-height: 70px;
    }
}
</style>

<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-8 col-xl-7 text-center text-lg-left justify-content-center d-flex flex-column align-items-center align-items-lg-start order-1 order-lg-0">
                <h2 class="mb-16" :class="{'mb-md-40': !description, 'mb-md-24': description}" v-html="title"></h2>
                <p v-if="description" class="mb-16 mb-md-40 font-weight-light">{{ description }}</p>
                <div class="d-flex align-items-center flex-column flex-lg-row">
                    <a :href="`/${ctaLink}`" class="btn btn-accent text-center">{{ cta }} <span v-html="svg('arrow-right', 'arrow-right')" /></a>
                    <a v-if="email" :href="`mailto:${email}`" class="ml-lg-32 small text-dark mr-lg-16 mt-32 mt-lg-0">{{email}}</a>
                    <span v-if="email && phone" class="small d-none d-lg-inline">|</span>
                    <a v-if="phone"  :href="`tel:${phone}`" class="ml-lg-16 small text-dark mt-16 mt-lg-0">{{phone}}</a>
                </div>
            </div>
            <div class="col-12 col-lg-4 col-xl-5 d-flex justify-content-center justify-content-lg-end order-0 order-lg-1 mb-24 mb-lg-0">
                <img class="circle" :src="src" :alt="title">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pageParts.ask-banner-row",

    props: {
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
        },
        cta: {
            type: String,
            default: ''
        },
        ctaLink: {
            type: String,
            required: true,
        },
        src: {
            type: String,
            default: ''
        },
        phone: {
            type: String,
            default: null
        },
        email: {
            type: String,
            default: null
        }
    }
}
</script>
